import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
function slicePathSegments(pathname, start, end) {
  var startsWithSlash = pathname[0] === '/';
  var slicedPathname = pathname.split('/').filter(Boolean).slice(start, end).join('/');
  return startsWithSlash ? "/".concat(slicedPathname) : slicedPathname;
}
export function stripSlashFromEnd(pathname) {
  var endsWithSlash = pathname[pathname.length - 1] === '/';
  return endsWithSlash ? pathname.slice(0, -1) : pathname;
}
export default slicePathSegments;